export default __webpack_public_path__ + "static/media/georgia.7eb0e3ce.ttf";